import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { StyleSheet, css } from 'aphrodite';

import { SubHeading } from '../../components';

import '../../App.css';

const Newsletter = () => {
  const [state, handleSubmit] = useForm('mbljldjz');

  // Show thank you message if submission succeeded
  if (state.succeeded) {
    return (
      <div className={css(styles.thankYou)}>
        Thank you for joining Us!
      </div>
    );
  }

  return (
    <div className={css(styles.wrapper)}>
      {/* Subheading */}
      <SubHeading title="Subscribe" />

      {/* Description */}
      <p className={css(styles.description)}>
        Subscribe to our newsletter for specials, events, and more delights.
      </p>

      {/* Subscription Form */}
      <form
        id="subscription-form"
        onSubmit={handleSubmit}
        action="https://formspree.io/f/mbljldjz"
        method="POST"
        className={css(styles.form)}
      >
        <input
          id="email"
          type="email"
          name="email"
          placeholder="Your email here..."
          className={css(styles.input)}
          errors={state.errors}
        />
        <ValidationError prefix="Email" field="email" />

        <button type="submit" className="univeral__button" disabled={state.submitting}>
          Send
        </button>
      </form>
    </div>
  );
};

export default Newsletter;

// ---------------------------- STYLES ----------------------------
const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    minHeight: '200px',
    padding: '4rem 2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    color: 'var(--color-white)',
    background: 'var(--color-green)',
    '@media (max-width: 650px)': { padding: '3rem 1rem' },
  },
  thankYou: {
    width: '100%',
    textAlign: 'center',
    padding: '3rem',
    color: '#aaa',
    fontSize: '17px',
  },
  description: {
    fontFamily: 'var(--font-alt)',
    color: 'rgba(255,253,247,.7)',
    fontSize: '16px',
    textAlign: 'center',
    marginBottom: '2rem',
    '@media (max-width: 650px)': { fontSize: '14px', marginBottom: '1.5rem' },
  },
  form: {
    width: '590px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (max-width: 620px)': { width: '100%' },
  },
  input: {
    width: '100%',
    fontFamily: 'var(--font-alt)',
    padding: '0.8rem 1rem',
    marginBottom: '1rem',
    fontSize: '1rem',
    borderRadius: '999px',
    border: '1px solid rgba(255,255,255,.28)',
    outline: 'none',
    backgroundColor: 'rgba(255,255,255,.08)',
    color: 'var(--color-white)',
    ':hover': { border: '1px solid var(--color-golden)' },
    ':focus': { backgroundColor: 'rgba(255,255,255,.12)', borderColor: 'var(--color-golden)' },
  },
  
});
